import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Divider, Space } from '@redlink/components/atoms';
import { PreviewPostCard } from '@redlink/components/molecules';
import { PreviewShopPostCardCountBlock } from './previewShopPostCardCountBlock';
import {
  PreviewShopPostCardTextBlock,
  PreviewShopSimplePostCardTextBlock,
} from './previewShopPostCardTextBlock';

export const PreviewShopPostCard = memo(
  ({ item, style, onPress, compact, smallTile }) => {
    const { styles, colors } = useStyle();
    const {
      images = [],
      title,
      price,
      discount,
      category: { title: categoryTitle } = {},
    } = item;

    return (
      <PreviewPostCard
        {...{ style, onPress, images, compact, smallTile }}
        BodyComponent={
          <PreviewShopPostCardTextBlock
            style={styles.textBlockContainer}
            {...{ title, categoryTitle, price, discount }}
          />
        }
      >
        {/* <Space size={8} />
        <Divider color={colors.saparator} style={styles.divider} />
        <PreviewShopPostCardCountBlock {...{ item }} /> */}
        <Space size={8} />
      </PreviewPostCard>
    );
  }
);

export const PreviewShopSimplePostCard = memo(
  ({ item, style, onPress, compact, smallTile }) => {
    const { styles } = useStyle();
    const {
      images = [],
      title,
      price,
      discount,
      category: { title: categoryTitle } = {},
    } = item;

    return (
      <PreviewPostCard {...{ style, onPress, images, compact, smallTile }}>
        <PreviewShopSimplePostCardTextBlock
          style={styles.textBlockContainer}
          {...{ title, categoryTitle, price, discount }}
        />
      </PreviewPostCard>
    );
  }
);

const useStyle = createUseStyle(
  ({ colors, shadow, size, ltrFlexDirection }) => ({
    textContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    divider: {
      marginHorizontal: 16,
    },
    textBlockContainer: {
      marginHorizontal: 16,
      marginTop: 8,
      marginBottom: 16,
    },
  })
);
